<template>
  <!-- FIXME 将来ApproachedSummaryにできたら統合-->
  <section class="boss-approach-info">
    <table class="unstriped boss-table">
      <thead>
        <tr>
          <th class="boss-table-head">
            アプローチした求人
            <span
              v-tooltip="{ content: '現在の掲載期間中に送信したスカウトは濃色で表示、それ以前に送信していた場合は薄色で表示されます。'}"
              class="pega-circle"
            >?</span>
          </th>
          <th class="boss-table-head">
            スカウト
          </th>
          <th class="boss-table-head">
            スカウト特典
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(scoutsSummary, i) in scouts_summaries"
          :key="i"
        >
          <td
            :data-test="'management-name-' + scoutsSummary.job.id"
            class="boss-table-data boss-ellipsis-block"
          >
            求人ID: {{ scoutsSummary.job.id }} {{ scoutsSummary.job.managementName }}
          </td>
          <td class="boss-table-data">
            <span
              :data-test="'scout-ellipse-' + scoutsSummary.job.id"
              :class="{ 'pega-gray-color-important': !scoutsSummary.isScoutEffective }"
              class="boss-icon-ellipse"
            />
          </td>
          <td class="boss-table-data">
            <span
              v-for="(specialFavor, j) in scoutsSummary.specialFavors"
              :key="j"
              v-tooltip="{ content: specialFavorBy(specialFavor.id).description}"
              :data-test="'special-favor-' + scoutsSummary.job.id + '-' + specialFavor.id"
              :class="{ 'boss-bonus-end': !specialFavor.isEffective }"
              class="boss-bonus-check-text boss-check-true"
            >{{ specialFavor.name }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    contractId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      scouts_summaries: []
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    })
  },
  created () {
    this.fetchScoutsSummaries()
  },
  methods: {
    fetchScoutsSummaries () {
      this.$http.secured.get(`/scout/view/scouts/contracts/${this.contractId}/users/${this.userId}/scouts_summaries`)
        .then(response => this.setProperty(response))
    },
    setProperty (response) {
      this.$set(this, 'scouts_summaries', response.data)
    }
  }
}
</script>
